import { Pipe, PipeTransform } from '@angular/core';
import {
  DayDate,
  LOCALIZED_FORMAT,
  LOCALIZED_FORMAT_WITHOUT_TIME,
} from '@deltager/organizers/admin/core/date-format/dayDate';

@Pipe({ name: 'dayDate' })
export class DayDateFormatPipe implements PipeTransform {
  constructor() {}

  transform(date: string | Date | null | undefined, withoutTime?: boolean, utc?: boolean): string {
    let parsedDate = DayDate.new(date);

    if (utc) {
      parsedDate = DayDate.new(DayDate.toUtc(date, true));
    }

    if (parsedDate) {
      return parsedDate.format(!withoutTime ? LOCALIZED_FORMAT : LOCALIZED_FORMAT_WITHOUT_TIME);
    }

    return '';
  }
}
